import axios from "axios";
import TransactionQueryResponse from "accounting-data-types/dist/APIG/Transaction/TransactionQueryResponse";
import { JsonConvert, OperationMode, ValueCheckingMode } from "json2typescript";
let jsonConvert = new JsonConvert();
jsonConvert.operationMode = OperationMode.ENABLE;
jsonConvert.ignorePrimitiveChecks = false;
jsonConvert.valueCheckingMode = ValueCheckingMode.DISALLOW_NULL;
export default class AccountApiClient {
    constructor(pBaseUrl, pUser) {
        this.baseUrl = pBaseUrl;
        this.user = pUser;
    }
    async getTransactionAudit(queryOptions) {
        const apiUrl = this.baseUrl + '/transactions/query';
        let apiResult;
        try {
            apiResult = await axios.post(apiUrl, queryOptions, this.getHeader());
            console.log("API Response: " + JSON.stringify(apiResult.data));
        }
        catch (error) {
            throw new Error("Failed to get transaction audits from API. " + error.message);
        }
        let txnResponse = new TransactionQueryResponse();
        if (apiResult.status === 200) {
            try {
                txnResponse = jsonConvert.deserializeObject(apiResult.data, TransactionQueryResponse);
                console.log("Deserialization: " + JSON.stringify(txnResponse));
            }
            catch (error) {
                console.log("Failed to deserialize audit. Error: " + error.message);
            }
        }
        return txnResponse;
    }
    getHeader() {
        return {
            headers: {
                'Authorization': this.user.access_token,
                'Content-Type': 'application/json'
            }
        };
    }
}
